import { LoginForm, ProFormText } from '@ant-design/pro-components';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { App as AntdApp, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { adminLogin, type LoginPayload } from '@/api/auth';
import { useAuthStore } from '@/stores/auth';

export default function LoginPage() {
  const navigate = useNavigate();
  const setTokens = useAuthStore((s) => s.setTokens);
  const setUser = useAuthStore((s) => s.setUser);

  const handleSubmit = async (values: LoginPayload) => {
    try {
      const resp = await adminLogin(values);
      setTokens(resp.access, resp.refresh);
      setUser(resp.user);
      navigate('/dashboard', { replace: true });
    } catch (e) {
      // 拦截器已弹错; 这里阻止 LoginForm 标记成功
      throw e;
    }
  };

  return (
    <AntdApp>
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #1677ff 0%, #69b1ff 100%)',
        }}
      >
        <Card
          style={{ width: 420, boxShadow: '0 10px 40px rgba(0,0,0,0.15)' }}
          styles={{ body: { padding: 0 } }}
        >
          <LoginForm<LoginPayload>
            title="普通话考试管理后台"
            subTitle="Mandarin-Project Admin"
            onFinish={handleSubmit}
            submitter={{ searchConfig: { submitText: '登录' } }}
          >
            <ProFormText
              name="username"
              fieldProps={{ size: 'large', prefix: <UserOutlined /> }}
              placeholder="用户名"
              rules={[{ required: true, message: '请输入用户名' }]}
            />
            <ProFormText.Password
              name="password"
              fieldProps={{ size: 'large', prefix: <LockOutlined /> }}
              placeholder="密码"
              rules={[{ required: true, message: '请输入密码' }]}
            />
          </LoginForm>
        </Card>
      </div>
    </AntdApp>
  );
}
